"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-component wf-component--select-production-to-lose" };
const _hoisted_2 = {
    key: 0,
    class: "nofloat wf-component-title"
};
const _hoisted_3 = { class: "payments_title" };
const _hoisted_4 = {
    key: 1,
    class: "payments_type input-group"
};
const _hoisted_5 = {
    key: 2,
    class: "payments_type input-group"
};
const _hoisted_6 = {
    key: 3,
    class: "payments_type input-group"
};
const _hoisted_7 = {
    key: 4,
    class: "payments_type input-group"
};
const _hoisted_8 = {
    key: 5,
    class: "payments_type input-group"
};
const _hoisted_9 = {
    key: 6,
    class: "payments_type input-group"
};
const _hoisted_10 = {
    key: 7,
    class: "tm-warning"
};
const _hoisted_11 = { class: "label label-error" };
const _hoisted_12 = {
    key: 8,
    class: "nofloat"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h3", _hoisted_3, [...(_cache[19] || (_cache[19] = [
                (0, vue_1.createTextVNode)("Which resource production would you prefer to decrease?", -1)
            ]))])), [
            [_directive_i18n]
        ]),
        (_ctx.canDeductMegaCredits())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                _cache[22] || (_cache[22] = (0, vue_1.createElementVNode)("div", { class: "production-box" }, [
                    (0, vue_1.createElementVNode)("div", {
                        class: "production resource_icon--megacredits",
                        style: { "background-size": "contain" }
                    })
                ], -1)),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.delta('megacredits', -1)))
                }, [...(_cache[20] || (_cache[20] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-minus" }, null, -1)
                    ]))]),
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    class: "form-input form-inline payments_input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.units.megacredits) = $event))
                }, null, 512), [
                    [
                        vue_1.vModelText,
                        _ctx.units.megacredits,
                        void 0,
                        { number: true }
                    ]
                ]),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.delta('megacredits', 1)))
                }, [...(_cache[21] || (_cache[21] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-plus" }, null, -1)
                    ]))])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.canDeductSteel())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [
                _cache[25] || (_cache[25] = (0, vue_1.createElementVNode)("div", { class: "production-box" }, [
                    (0, vue_1.createElementVNode)("div", { class: "production steel" })
                ], -1)),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.delta('steel', -1)))
                }, [...(_cache[23] || (_cache[23] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-minus" }, null, -1)
                    ]))]),
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    class: "form-input form-inline payments_input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.units.steel) = $event))
                }, null, 512), [
                    [
                        vue_1.vModelText,
                        _ctx.units.steel,
                        void 0,
                        { number: true }
                    ]
                ]),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.delta('steel', 1)))
                }, [...(_cache[24] || (_cache[24] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-plus" }, null, -1)
                    ]))])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.canDeductTitanium())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6, [
                _cache[28] || (_cache[28] = (0, vue_1.createElementVNode)("div", { class: "production-box" }, [
                    (0, vue_1.createElementVNode)("div", { class: "production titanium" })
                ], -1)),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.delta('titanium', -1)))
                }, [...(_cache[26] || (_cache[26] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-minus" }, null, -1)
                    ]))]),
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    class: "form-input form-inline payments_input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.units.titanium) = $event))
                }, null, 512), [
                    [
                        vue_1.vModelText,
                        _ctx.units.titanium,
                        void 0,
                        { number: true }
                    ]
                ]),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.delta('titanium', 1)))
                }, [...(_cache[27] || (_cache[27] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-plus" }, null, -1)
                    ]))])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.canDeductPlants())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7, [
                _cache[31] || (_cache[31] = (0, vue_1.createElementVNode)("div", { class: "production-box" }, [
                    (0, vue_1.createElementVNode)("div", { class: "production plant" })
                ], -1)),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.delta('plants', -1)))
                }, [...(_cache[29] || (_cache[29] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-minus" }, null, -1)
                    ]))]),
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    class: "form-input form-inline payments_input",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.units.plants) = $event))
                }, null, 512), [
                    [
                        vue_1.vModelText,
                        _ctx.units.plants,
                        void 0,
                        { number: true }
                    ]
                ]),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.delta('plants', 1)))
                }, [...(_cache[30] || (_cache[30] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-plus" }, null, -1)
                    ]))])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.canDeductEnergy())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8, [
                _cache[34] || (_cache[34] = (0, vue_1.createElementVNode)("div", { class: "production-box" }, [
                    (0, vue_1.createElementVNode)("div", { class: "production energy" })
                ], -1)),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.delta('energy', -1)))
                }, [...(_cache[32] || (_cache[32] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-minus" }, null, -1)
                    ]))]),
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    class: "form-input form-inline payments_input",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.units.energy) = $event))
                }, null, 512), [
                    [
                        vue_1.vModelText,
                        _ctx.units.energy,
                        void 0,
                        { number: true }
                    ]
                ]),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.delta('energy', 1)))
                }, [...(_cache[33] || (_cache[33] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-plus" }, null, -1)
                    ]))])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.canDeductHeat())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_9, [
                _cache[37] || (_cache[37] = (0, vue_1.createElementVNode)("div", { class: "production-box" }, [
                    (0, vue_1.createElementVNode)("div", { class: "production heat" })
                ], -1)),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[15] || (_cache[15] = ($event) => (_ctx.delta('heat', -1)))
                }, [...(_cache[35] || (_cache[35] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-minus" }, null, -1)
                    ]))]),
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    class: "form-input form-inline payments_input",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.units.heat) = $event))
                }, null, 512), [
                    [
                        vue_1.vModelText,
                        _ctx.units.heat,
                        void 0,
                        { number: true }
                    ]
                ]),
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary",
                    onClick: _cache[17] || (_cache[17] = ($event) => (_ctx.delta('heat', 1)))
                }, [...(_cache[36] || (_cache[36] = [
                        (0, vue_1.createElementVNode)("i", { class: "icon icon-plus" }, null, -1)
                    ]))])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.hasWarning())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_10, [
                (0, vue_1.createElementVNode)("label", _hoisted_11, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.warning)), 1)
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.showsave === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_12, [
                (0, vue_1.createElementVNode)("button", {
                    class: "btn btn-primary btn-submit",
                    onClick: _cache[18] || (_cache[18] =
                        (...args) => (_ctx.saveData && _ctx.saveData(...args)))
                }, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.buttonLabel)), 1)
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
